import React, { useRef, useEffect } from 'react';
import ChatHeader from '../chat/shared/ChatHeader';

// Wrapper for the shared ChatHeader to work in the public widget context
const PublicChatHeader = ({ customization, onClose, onMinimize, isMuted, setIsMuted, onFontSizeChange, hideMinimize }) => {
    const isMutedRef = useRef(isMuted);
    const soundEnabledRef = useRef(true); // Always true for widget

    // Keep isMutedRef in sync with isMuted
    useEffect(() => {
        isMutedRef.current = isMuted;
    }, [isMuted]);

    const handleToggleMute = () => {
        setIsMuted((prev) => !prev);
    };

    const handleToggleFontSize = () => {
        if (onFontSizeChange) onFontSizeChange();
    };

    return (
        <ChatHeader
            customization={customization}
            isMutedRef={isMutedRef}
            soundEnabledRef={soundEnabledRef}
            onToggleMute={handleToggleMute}
            onToggleMinimize={onMinimize}
            onToggleFontSize={handleToggleFontSize}
            onClose={onClose}
            isMuted={isMuted}
            setIsMuted={setIsMuted}
            devicePreview={"desktop"}
            hideMinimize={hideMinimize}
        />
    );
};

export default PublicChatHeader;
